import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
    root: {
        marginTop: '5rem',
        marginBottom:"3rem"
    },
    modalForm: {
        width: '100%'
    },
    layout: {
        width: 'auto',
        display: 'block', // Fix IE11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    avatar: {
        margin: `${theme.spacing(1)}px auto`,
        backgroundColor: theme.palette.primary.main,
        width: 80,
        height: 80,
        // borderRadius: 0
        '& svg': {
            // color: 'rgba(0, 0, 0, 0.87)',
            color: '#fff'
        }
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        marginTop: theme.spacing(3),
    },
    fieldError: {
        color: '#FF0000'
    },
    item: {
        '&:not(:last-child)': {
            marginBottom: '0 !important',
            borderBottom: '1px solid #ECECEC'
        },
        '&:hover': {
            cursor: 'default !important',
            '& $itemCheckbox': {
                opacity: '0 !important'
            },
            '& $itemWrapper': {
                boxShadow: 'none !important'
            }
        },
        '& $itemContent': {
            boxShadow: 'none'
        }
    },
    itemColumn: {
        '& img': {
            objectFit: 'contain !important'
        }
    },
    idColumn: {
        width: '500px',
    },
    itemCheckbox: {},
    itemWrapper: {},
    itemContent: {},
    colLineTitle: {
        '&.mainTitle': {
            fontSize: '1rem'
        },
        '&.subTitle': {
            color: '#808080'
        }
    },
    statusBtns: {
        width: '20%',
        maxWidth: '300px',
    },
    statusBtn: {
        margin: '2px 0px',
        width: '100%',
        minHeight: '36px',
        maxWidth: '129px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '3px 25px',
        boxShadow: 'none',
    },
    transactionToolbar: {
        width: 'unset',
        marginLeft: '40px',
        padding: "0px 120px ",
        [theme.breakpoints.up('md')]: {
            width: 'calc(100% - 42px - 8px - 50px)',
        },
    },
    failureBtn: {
        color: '#E71919',
        border: '1px solid #E71919'
    },
    successBtn: {

    },
    statusBtnDisable: {
        padding: '5px 55px',
        maxWidth: '271px'
    },
    boxStatus: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    detailTextCustomer: {
        fontSize: '12px',
        fontWeight: '400',
        margin: '5px 0px'
    },
    header: {
        position: 'fixed',
        left: '0%',
        right: '0%',
        height: '60px',
        background: '#41B60B',
        color: 'white',
        'z-index': '100',
        'align-items': 'center',
        display: 'flex',
        padding: '0 20px',
        top: "0%",
    },
    drawIconClose: {
        width: "30px",
        height: "30px",
        color: 'white',
        "& img": {
          width: "20px",
        },
    },
    textClose:{
        'padding-left': '14px',
        'font-size': '18px',
        color: 'white',
        'line-height': '30px',
    },
    wrapIconClose: {
        display: 'flex',
        alignItems:'center',
        cursor: 'pointer'
    },
    itemDetail: {
        width: 'calc(100% - 42px * 2 - 8px * 2)'
    },
    dailyInvoiceDetail: {
        padding: '2rem',
        '&:not(:last-child)': {
            borderBottom: '1px solid #ECECEC'
        }
    },
    currentBalance:{
        color: '#41B60B',
        fontSize: '36px',
        lineHeight: '42px',
        paddingRight: "10px"
    },
    btnToday:{
        border:'1px solid #41B60B !important',
        '&:hover':{
            border: '1px #41B60B !important',
            boxShadow: '5px 5px 10px  #888888'
        }
    }
}))